import { render, staticRenderFns } from "./SelectScholar.vue?vue&type=template&id=7061d35a&scoped=true&"
import script from "./SelectScholar.vue?vue&type=script&lang=ts&"
export * from "./SelectScholar.vue?vue&type=script&lang=ts&"
import style0 from "./SelectScholar.less?vue&type=style&index=0&id=7061d35a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7061d35a",
  null
  
)

export default component.exports